import Calendar from "react-calendar";
import StartOverButton from "../../Buttons/StartOverButton/StartOverButton";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import "./StepTwo.css";
import { DateTime } from "luxon";

import {
  getDayAvailability,
  getLocationAvailability,
} from "../../../util/ApiCalls";
import {
  dateString,
  dateStringToDate,
  getDate,
  getHour,
  getYearMonth,
} from "../../../Coverters/dateConverters";
import { Loader } from "../../Loading/Loader";

const TimePicker = ({
  date,
  timeString,
  timeRows,
  times,
  selectedTime,
  timeSelectHandler,
}) => {
  // time slot setup
  const { t } = useTranslation();

  // ref to the tbody
  const tbodyRef = useRef(null);

  // arrow key handler for select time
  const handleKeyDown = (event) => {
    const active = document.activeElement;
    if (!active || !tbodyRef.current) return;
    const rows = Array.from(tbodyRef.current.querySelectorAll("tr"));

    // 2d array to use arrow keys to navigate the time slots
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const cells = Array.from(rows[rowIndex].querySelectorAll("td"));
      for (let colIndex = 0; colIndex < cells.length; colIndex++) {
        const button = cells[colIndex].querySelector("button");
        if (button === active) {
          let target = null;
          const availableWidth = window.innerWidth;

          switch (event.key) {
            case "ArrowRight":
              target = cells[colIndex + 1]?.querySelector("button");

              if (target === undefined) {
                target = rows[rowIndex + 1]
                  ?.querySelectorAll("td")[0]
                  ?.querySelector("button");
              }

              break;
            case "ArrowLeft":
              target = cells[colIndex - 1]?.querySelector("button");

              if (target === undefined) {
                target = rows[rowIndex - 1]
                  ?.querySelectorAll("td")[3]
                  ?.querySelector("button");
              }

              break;
            case "ArrowDown":
              target = rows[rowIndex + 1]
                ?.querySelectorAll("td")
                [colIndex]?.querySelector("button");

              // for screen buttons when width dislays as
              // time - time
              // time - time

              if (availableWidth < 1088) {
                target = cells[colIndex + 2]?.querySelector("button");
              }

              if (availableWidth < 1088 && target === undefined) {
                target = rows[rowIndex + 1]
                  ?.querySelectorAll("td")
                  [colIndex - 2]?.querySelector("button");
              }

              // for screen buttons when width dislays as
              // time
              // time

              if (availableWidth < 601) {
                target = cells[colIndex + 1]?.querySelector("button");
              }

              if (availableWidth < 601 && target === undefined) {
                target = rows[rowIndex + 1]
                  ?.querySelectorAll("td")
                  [colIndex - 3]?.querySelector("button");
              }

              break;
            case "ArrowUp":
              target = rows[rowIndex - 1]
                ?.querySelectorAll("td")
                [colIndex]?.querySelector("button");

              // for screen buttons when width dislays as
              // time - time
              // time - time

              if (availableWidth < 1088) {
                target = cells[colIndex - 2]?.querySelector("button");
              }

              if (availableWidth < 1088 && target === undefined) {
                target = rows[rowIndex - 1]
                  ?.querySelectorAll("td")
                  [colIndex + 2]?.querySelector("button");
              }

              // for screen buttons when width dislays as
              // time
              // time
              if (availableWidth < 601) {
                target = cells[colIndex - 1]?.querySelector("button");
              }

              if (availableWidth < 601 && target === undefined) {
                target = rows[rowIndex - 1]
                  ?.querySelectorAll("td")
                  [colIndex + 3]?.querySelector("button");
              }

              break;
            default:
              return;
          }

          if (target) {
            event.preventDefault();
            target.focus();
          }
          return;
        }
      }
    }
  };

  const container = {};
  for (const time of timeRows) {
    container[getHour(time)] = {
      time: getHour(time) + ":00",
      times: [],
    };
  }
  if (times.length > 0) {
    for (const time of times) {
      if (container[getHour(time.time)]) {
        container[getHour(time.time)]?.times.push(time);
      }
    }
  }
  let locale = t("scheduleAppointmenPage.calendarLocale");
  return (
    <table
      className="step-time-container"
      style={{ width: "100%" }}
      role="grid"
    >
      <tbody
        tabIndex="-1"
        ref={tbodyRef}
        onKeyDown={handleKeyDown}
        style={{
          // overflowY: "scroll",
          // height: "600px",
          width: "auto",
          flexDirection: "row",
        }}
        className="tableWidth time-table"
      >
        <div className={"flex"}>
          <div
            aria-hidden="true"
            tabIndex={"-1"}
            className={"rowLabelHidden"}
            style={{ padding: "31px" }}
          ></div>
          <th
            style={{ fontSize: "40px", margin: "10px", padding: "10px" }}
            aria-label={`${getDate(date, locale)}, ${timeString}`}
            tabIndex={"-1"}
          >
            {getDate(date, locale)}, {timeString}
          </th>
        </div>
        {Object.keys(container)
          .sort((k1, k2) => k1.localeCompare(k2))
          .map((key, i) => {
            const row = container[key];
            let btns = [];
            for (const [index, slot] of row.times.entries()) {
              // time slot button
              btns.push(
                <td className="table-data" role={"presentation"}>
                  <button
                    type={"button"}
                    role={"gridcell"}
                    tabIndex={
                      (index === 0 && i === 0) || selectedTime === slot.time
                        ? 0
                        : -1
                    }
                    className={
                      slot.appointment
                        ? "booked bookingBtn"
                        : slot.available
                          ? "notBooked bookingBtn"
                          : "notAvailable bookingBtn"
                    }
                    disabled={!slot.available}
                    onClick={
                      selectedTime === slot.time
                        ? (e) => timeSelectHandler(e, null)
                        : (e) => timeSelectHandler(e, slot.time)
                    }
                    onKeyDown={
                      selectedTime === slot.time
                        ? (e) => timeSelectHandler(e, null)
                        : (e) => timeSelectHandler(e, slot.time)
                    }
                    style={{
                      background: slot.time === selectedTime ? "blue" : null, // 4.5 color contrast
                      color: slot.time === selectedTime ? "white" : null, // 4.5 color contrast
                      margin: "2px",
                      flex: "1 1",
                    }}
                    aria-label={slot.time}
                  >
                    {slot.time}
                  </button>
                </td>,
              );
            }
            return (
              <tr
                className={
                  "flex time-row rowButtons row row-no-gutters col-xl-12"
                }
              >
                <button tabIndex="-1" className={"rowLabel"}>
                  {row.time}
                </button>
                <div className="time-select-button">{btns}</div>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export const StepTwo = ({
  selectedTime,
  date,
  setDate,
  setSelectedTime,
  nextHandler,
  backHandler,
  wloc,
  requiredTime,
}) => {
  const { portWorklocations } = useSelector((state) => state.portWorklocations);
  const { applicationTitle } = useSelector((state) => state.applicationTitle);
  const [times, setTimes] = useState([]);
  const [openDays, setOpenDays] = useState([]);
  const [noOpenDaysFound, setNoOpenDaysFound] = useState(false);
  const [timeRows, setTimeRows] = useState([]);
  const [timesLoading, setTimesLoading] = useState(true);
  const [nextDate, setNextDate] = useState(new Date());
  const [currentLocation, setCurrentLocation] = useState("");
  const [failedToGetTime, setFailedToGetTime] = useState(false);
  const { t } = useTranslation();
  let lang = localStorage.getItem("locale");
  const nextButtonRef = useRef(null);

  const getTomorrow = async () => {
    // Search up to 6 months from today
    const futureDate = DateTime.now().plus({ months: 6 });

    // Get next available date
    let nextDate = DateTime.now();
    let dateStr = nextDate.toISODate(); // yyyy-MM-dd

    let availability = await getDayAvailability(wloc.value, dateStr);

    do {
      nextDate = nextDate.plus({ days: 1 });
      dateStr = nextDate.toISODate();

      availability = await getDayAvailability(wloc.value, dateStr);
    } while (availability?.data?.length < 1 && nextDate <= futureDate);

    if (availability?.data?.length > 0) {
      nextDate = DateTime.fromISO(availability.data[0].date);
    }

    if (nextDate) {
      setNextDate(nextDate.toJSDate());
    } else {
      setNextDate(new Date());
    }
  };

  useEffect(() => {
    getTomorrow();
  }, [wloc]);

  function filterByValue(array, canadianPort, isUsa) {
    let returnArray = [];
    if (array) {
      for (let i = 0; i < array?.length; i++) {
        for (let j = 0; j < array[i].parameters.length; j++) {
          if (
            array[i]?.parameters[j]?.value === canadianPort &&
            array[i]?.parameters[j]?.key === isUsa
          ) {
            let results = array[i];

            returnArray.push(results);
          }
        }
      }
    }

    return returnArray;
  }

  const filterWlocByLocale = () => {
    if (portWorklocations.length !== 0) {
      let w = portWorklocations
        ?.map((ele) => {
          return {
            value: ele.id,
            label:
              lang === "en" ? ele.descriptionEnglish : ele.descriptionFrench,
            parameters: ele.parameters,
          };
        })
        .sort((o1, o2) => o1?.label?.localeCompare(o2?.label));

      let filterCanadianPorts = filterByValue(w, "false", "isUSA");

      let currLocation = filterCanadianPorts.filter(
        (item) => item.value === wloc.value,
      );

      setCurrentLocation(currLocation[0]);
    }
  };

  useEffect(() => {
    filterWlocByLocale();
  }, [lang]);

  /**
   * @param timeslots {[{locationId, date, time, available}]}
   */
  const processTimeslot = (timeslots) => {
    // const timesList = [];
    if (!Array.isArray(timeslots)) {
      return;
    }

    // sort time slots by time. We are only asking for one day at a time so we only look at the time component.
    timeslots.sort((a, b) => a.time.localeCompare(b.time));

    // If times are in format HH:mm:ss, remove the ":ss"
    timeslots.forEach((ts) => (ts.time = ts.time.slice(0, 5)));

    // for (const slot of timeslots) {
    //     if (slot) {
    //         const timeSplice = slot.split(":");
    //         const time = timeSplice[0] + ":" + timeSplice[1];
    //         timesList.push(time);
    //     }
    // }

    // todo - May 19 - FIX THIS to set if this time slot/location is that of the current appointment.
    setTimes(timeslots.map((time) => ({ ...time, appointment: false })));

    // build the hour
    let uniqueHours = [];
    for (let t of timeslots) {
      let hour = getHour(t.time);
      uniqueHours.push(hour + ":00");
    }
    setTimeRows(uniqueHours);
  };

  //combine two 90 range calls
  //param2 starts 1 day after param1
  const combineAvailability = (first90DaysParam, second90DaysParam) => {
    if (
      Array.isArray(first90DaysParam) &&
      Array.isArray(second90DaysParam) &&
      first90DaysParam.length > 0 &&
      second90DaysParam.length > 0
    ) {
      let dayMap = new Map();

      //add first 90 days to map
      first90DaysParam.forEach((item) => {
        dayMap.set(item.date, { ...item });
      });

      //add next 90 days
      second90DaysParam.forEach((item) => {
        if (!dayMap.has(item.date)) {
          dayMap.set(item.date, { ...item });
        }
      });
      //return combined
      return Array.from(dayMap.values()).sort(
        (day1, day2) => new Date(day1.date) - new Date(day2.date),
      );
    }

    return null;
  };

  const findAvaliabilities = async () => {
    const dateStr = dateString(date);

    setTimesLoading(true);

    //get first 90 days
    const today = new Date();
    const end = new Date();
    //original 180 day call
    // end.setDate(today.getDate() + 180);
    end.setDate(today.getDate() + 90);

    let firstResults = await getLocationAvailability(
      wloc?.value,
      dateString(today),
      dateString(end),
    );

    //get next 90 days, from t1e last dat of end.setDate(today.getDate() + 90);
    const secondStartDate = new Date(end);
    secondStartDate.setDate(secondStartDate.getDate() + 1);

    const secondEndDate = new Date(secondStartDate);
    secondEndDate.setDate(secondEndDate.getDate() + 90);

    let secondResults = await getLocationAvailability(
      wloc?.value,
      dateString(secondStartDate),
      dateString(secondEndDate),
    );

    //check status here
    if (
      firstResults?.status === 404 ||
      firstResults?.status === 500 ||
      secondResults?.status === 404 ||
      secondResults?.status === 500
    ) {
      setNoOpenDaysFound(true);
    } else {
      // add handler to make sure it isnt coming basck as data: "" <- happens when making a large call, that is why we split it into two calls and combine
      //combines 180days
      // return null if one or the other isn't an array
      let openResults = combineAvailability(
        firstResults.data,
        secondResults.data,
      );

      const todayString = dateString(today);
      let openDayAvailable;

      // add some handler here to check if the results are empty, which causes a loading issue
      if (openResults !== null) {
        openDayAvailable = openResults
          .filter((day) => day.available === true && day.date !== todayString)
          .map((day) => day.date);
      }

      //if openDayAvailable is undefined it means we got back a null from one of the 90 day calls.
      if (openDayAvailable?.length === 0 || openDayAvailable === undefined) {
        setTimesLoading(false);
        setNoOpenDaysFound(true);
        setFailedToGetTime(true);
      } else {
        setOpenDays(openDayAvailable);

        //create the click able time for user
        let dayAvaliability;
        if (dateStr !== undefined) {
          dayAvaliability = await getDayAvailability(wloc?.value, dateStr);
          processTimeslot(dayAvaliability?.data);
        }
      }
    }
  };

  const getDayTimeSlots = async (wloc, date) => {
    const dateStr = dateString(date);

    if (dateStr === undefined) {
      return;
    } else {
      setTimesLoading(true);
      let dayAvaliability = await getDayAvailability(wloc?.value, dateStr);

      if (dayAvaliability?.status !== 200) {
        setNoOpenDaysFound(true);
      } else {
        processTimeslot(dayAvaliability?.data);
        setTimesLoading(false);
      }
    }
  };

  useEffect(() => {
    findAvaliabilities();
  }, []);

  useEffect(() => {
    getDayTimeSlots(wloc, date);
  }, [date]);

  useEffect(() => {
    if (openDays) {
      findMinOpenDate(openDays);
    }
  }, [openDays]);

  const calendarHandlder = (value) => {
    setDate(value);
  };

  const timeSelectHandler = (e, value) => {
    if (e.key === "Enter" && value !== null) {
      setSelectedTime(value);
      e.preventDefault();
      nextButtonRef.current.focus();
    }

    if (e.type === "click") {
      setSelectedTime(value);
    }
  };

  const filterTile = ({ activeStartDate, date: dateStr, view }) => {
    if (view === "month") {
      return !openDays.some((days) => days === dateString(dateStr));
    }

    if (view === "year") {
      return !openDays.some(
        (days) => days.slice(0, 7) === getYearMonth(dateStr),
      );
    }
  };

  useEffect(() => {
    const calendarDates = document.querySelectorAll(
      ".react-calendar__month-view__weekdays__weekday",
    );

    calendarDates.forEach((dates) => {
      const text = dates.textContent?.trim();

      const fullDayName = {
        Sun: "Sunday",
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
      }[text || ""];

      if (fullDayName) {
        let readerContainer = document.createElement("div");
        let date = document.createElement("span");
        let hiddenDate = document.createElement("span");

        date.textContent = text;
        date.setAttribute("aria-hidden", "true");

        hiddenDate.setAttribute("class", "soundReader");
        hiddenDate.textContent = fullDayName;

        readerContainer.setAttribute("aria-label", fullDayName);
        readerContainer.appendChild(date);
        readerContainer.appendChild(hiddenDate);
        readerContainer.setAttribute("tabIndex", 0);
        dates.replaceWith(readerContainer);
      }
    });
  });

  /**
   * Find the min date for the work location
   */
  const findMinOpenDate = (openDaysList) => {
    const firstDay = dateStringToDate(openDaysList[0]);
    setDate(firstDay);
  };

  let content = noOpenDaysFound ? (
    ""
  ) : (
    <>
      <Loader
        loading={openDays?.length < 1 || !date}
        loadingLabel={t("global.loading")}
        content={
          // Main content
          <div>
            {/* Color boxes */}
            <div style={{ marginRight: "20px", textAlign: "right" }}>
              <div className="legend-container">
                <p>{t("stepTwo.grey")}</p>
                <div className="greyBox">
                  <s className="greyBoxFont"></s>
                </div>
              </div>
              <div className="legend-container">
                <p className="tab-reverse">{t("stepTwo.blue")}</p>
                <div className="blueBox"></div>
              </div>

              {requiredTime ? null : (
                <p
                  className="required-text step-two-error"
                  tabIndex={0}
                  role="alert"
                  aria-live="assertive"
                >
                  {t("scheduleAppointmenPage.timeRequired")}
                </p>
              )}
            </div>
            <div
              className="contentContainer"
              style={{ justifyContent: "space-around" }}
            >
              <div className="calendarWidth">
                <div className={"wlocLabel"}>
                  <h2 tabIndex={0} className={"bold"}>
                    {currentLocation.label}
                  </h2>
                </div>
                <div tabIndex={0} aria-label={t("stepTwo.selectADate")}>
                  <Calendar
                    onChange={calendarHandlder}
                    value={date}
                    defaultValue={date}
                    calendarAriaLabel={"Select Calender"}
                    tileDisabled={filterTile}
                    calendarType={"US"}
                    locale={t("scheduleAppointmenPage.calendarLocale")}
                    nextAriaLabel={"Next Month"}
                    prevAriaLabel={"Previous Month"}
                    next2AriaLabel={"Previous Year"}
                    prev2AriaLabel={"Previous Year"}
                    className={"calendar-style"}
                    showNeighboringMonth={false}
                    prev2Label={null}
                    next2Label={null}
                    minDetail={"year"}
                    // tileAriaLabel={({date, view}) =>{
                    //   if(view === 'month'){
                    //     return `This is ${date.toDateString()}`
                    //   }
                    //   return undefined
                    // }}
                  />
                </div>
              </div>
              <div style={{ display: "flow", widht: "auto" }}>
                <>
                  <div
                    className="hide-alert-msgs"
                    role={timesLoading ? "alert" : "none"}
                    aria-live="assertive"
                  >
                    {timesLoading
                      ? t("loading.stepTwo")
                      : t("loading.stepTwoFinish")}
                  </div>
                  <Loader
                    loadingLabel={t("loading.time")}
                    loading={timesLoading}
                    minHeight={"600px"}
                    content={
                      <TimePicker
                        date={date}
                        timeRows={timeRows}
                        timeString={selectedTime}
                        times={times}
                        selectedTime={selectedTime}
                        timeSelectHandler={timeSelectHandler}
                      />
                    }
                  />
                </>
              </div>
            </div>
            <div className="stepButtonContainer">
              <button
                className="buttonStyling"
                onClick={() => nextHandler(selectedTime)}
                // tabIndex={0}
                // disabled={!selectedTime}
                ref={nextButtonRef}
              >
                {t("stepThree.next")}
              </button>
            </div>
          </div>
        }
      />
    </>
  );

  return (
    <div id={"wb-cont"} className="mainContainer">
      <div className="homeTitleContainer">
        <h1>{t("stepTwo.title")}</h1>
        <br></br>
        <p>
          {noOpenDaysFound
            ? failedToGetTime
              ? ""
              : `${wloc.label} ${t("stepTwo.noWP")}`
            : t("stepTwo.bodyText")}
        </p>

        <p>
          {failedToGetTime ? (
            <p className="required-text step-two-error">
              {t("scheduleAppointmenPage.refreshPage")}
            </p>
          ) : (
            ""
          )}
        </p>

        <p>{t("stepTwo.backText")}</p>
      </div>
      <div className="timeContainer">{content}</div>
      <div className="bottomButtonContainer bottomNavSpacing">
        <button className="startOverBtn" onClick={backHandler}>
          {t("button.back")}
        </button>
        <StartOverButton />
      </div>
    </div>
  );
};

export default StepTwo;
